/* BotForge — Product Gallery Carousel (arrows + dots + fade) */
(function(){
  if (!document.body.classList.contains('template-product')) return;

  function init() {
    var gallery = document.querySelector('media-gallery .product__media-list')
               || document.querySelector('.product__media-list');
    if (!gallery) return;

    var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));
    if (items.length < 2) return;

    /* Hide Dawn's thumbnail row — we replace with dots */
    document.querySelectorAll('.thumbnail-list, .thumbnail-slider, slider-component.thumbnail-slider, .product__media-gallery-thumbnails')
      .forEach(function(el){ el.style.display = 'none'; });

    gallery.classList.add('bf-carousel');
    items.forEach(function(it, i){
      it.classList.add('bf-slide');
      if (i === 0) it.classList.add('bf-active');
    });

    var wrap = gallery.parentElement;
    wrap.classList.add('bf-carousel-wrap');

    var prev = document.createElement('button');
    prev.className = 'bf-arrow bf-prev';
    prev.type = 'button';
    prev.setAttribute('aria-label','Previous image');
    prev.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';

    var next = document.createElement('button');
    next.className = 'bf-arrow bf-next';
    next.type = 'button';
    next.setAttribute('aria-label','Next image');
    next.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';

    wrap.appendChild(prev);
    wrap.appendChild(next);

    var dots = document.createElement('div');
    dots.className = 'bf-dots';
    items.forEach(function(_, i){
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'bf-dot' + (i === 0 ? ' bf-dot-active' : '');
      d.setAttribute('aria-label','Go to image ' + (i+1));
      d.setAttribute('data-bf-dot', i);
      dots.appendChild(d);
    });
    wrap.appendChild(dots);

    var current = 0;
    var dotEls = dots.querySelectorAll('.bf-dot');

    function goto(i){
      if (i < 0) i = items.length - 1;
      if (i >= items.length) i = 0;
      if (i === current) return;
      items[current].classList.remove('bf-active');
      items[i].classList.add('bf-active');
      dotEls[current].classList.remove('bf-dot-active');
      dotEls[i].classList.add('bf-dot-active');
      current = i;
    }

    prev.addEventListener('click', function(){ goto(current - 1); reset(); });
    next.addEventListener('click', function(){ goto(current + 1); reset(); });
    dots.addEventListener('click', function(e){
      var t = e.target.closest('.bf-dot');
      if (!t) return;
      goto(parseInt(t.getAttribute('data-bf-dot'), 10));
      reset();
    });

    /* Touch swipe */
    var sx = 0;
    wrap.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, { passive: true });
    wrap.addEventListener('touchend', function(e){
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) { goto(current + (dx < 0 ? 1 : -1)); reset(); }
    });

    /* Auto-advance */
    var auto = null;
    function start(){ auto = setInterval(function(){ goto(current + 1); }, 6000); }
    function reset(){ if (auto) clearInterval(auto); start(); }
    start();
    wrap.addEventListener('mouseenter', function(){ if (auto) clearInterval(auto); });
    wrap.addEventListener('mouseleave', start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 0);
  }
})();
